import React from "react";
import classes from "./Loader.module.css";

interface props {
  isLoader: boolean;
}

export default function Loader({ isLoader }: props) {
  return (
    <>
      {isLoader ? (
        <div className={classes.loaderParent}>
          <p className={classes.loader}></p>
        </div>
      ) : null}
    </>
  );
}
